import { render, staticRenderFns } from "./InteractiveDataResults.vue?vue&type=template&id=5c8849bf&scoped=true&"
import script from "./InteractiveDataResults.vue?vue&type=script&lang=ts&"
export * from "./InteractiveDataResults.vue?vue&type=script&lang=ts&"
import style0 from "./InteractiveDataResults.vue?vue&type=style&index=0&id=5c8849bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8849bf",
  null
  
)

export default component.exports